"use strict";

module.exports = require('./getoffersjs/components/AdditionalTransaction').default;
